import React from 'react';

type H1V1Props = {
    title: string|null
}

const H1V1 = (props: H1V1Props) => {

    if(props.title === null) {
        return <></>;
    }

    return (
        <div className="h1-v1 h1-v1_lvl-type-1">
            <h1 className="h1-v1__text" >{props.title}</h1>
        </div>
    );
}

export { H1V1 }